import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Network problem — please check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg?.replace("Value error, ", "")).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export const TYPE_PATH = { movie: "movie", tv: "tv-show", anime: "anime" };
export const titleUrl = (t) => `/${TYPE_PATH[t.type]}/${t.slug}`;
export const fmtRuntime = (m) => (m ? `${Math.floor(m / 60) ? Math.floor(m / 60) + "h " : ""}${m % 60}m` : "");
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "");

export function trackEvent(type, extra = {}) {
  const p = new URLSearchParams(window.location.search);
  api.post("/track", {
    type,
    utm_source: p.get("utm_source") || sessionStorage.getItem("utm_source") || "",
    utm_medium: p.get("utm_medium") || "",
    utm_campaign: p.get("utm_campaign") || "",
    referrer: sessionStorage.getItem("first_ref") ?? document.referrer,
    path: window.location.pathname,
    ...extra,
  }).catch(() => {});
}
